/**
 * Who is on the books.
 *
 * Separate from the live map, which is the other list of drivers in the console and answers
 * a different question — the map shows who is out there now, this shows who the firm
 * employs. A settings screen giving one driver a different daily rate needs the second,
 * including the driver at home asleep and the one who has left.
 */

import { request, type Schema } from '@taxi/api-client';

export type FleetDriver = Schema<'RosterDriver'>;

export const driversApi = {
  list: () => request<FleetDriver[]>('/api/tenant/drivers'),
};
